import type { PatSnapSuccessResponseData, PsHttp, PsHttpChannel } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

import type {
    GetCompanyTreeApi,
    GetCompanyTreeRequest,
    GetCompanyTreeResponse,
} from '../company-tree-api';
import type {
    GetCompanyNameApi,
    GetCompanyNameRequest,
    GetCompanyNameResponse,
} from '../company-name-api';
import { COMPANY_API_PATHS, getCoreTelecomApiUrlPrefix } from '../../constants';

@injectable()
export class CompanyTreeApiImpl
    extends PsHttpService
    implements GetCompanyTreeApi, GetCompanyNameApi {
    _coreTelecomApiUrlPrefix = '';

    constructor(httpClient: PsHttp, httpChannelClient: PsHttpChannel) {
        super(httpClient, httpChannelClient);
        this.init();
    }

    async init() {
        this._coreTelecomApiUrlPrefix = await getCoreTelecomApiUrlPrefix();
    }

    get options() {
        return {
            baseURL: this._coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getCompanyTree(data: GetCompanyTreeRequest): Promise<GetCompanyTreeResponse> {
        const result = await this.get<PatSnapSuccessResponseData<GetCompanyTreeResponse>>({
            url: COMPANY_API_PATHS.TREE,
            params: data,
        });
        return result.data;
    }

    async getCompanyByName(data: GetCompanyNameRequest): Promise<GetCompanyNameResponse> {
        const result = await this.post<PatSnapSuccessResponseData<GetCompanyNameResponse>>({
            url: COMPANY_API_PATHS.NAME,
            data,
        });
        return result.data;
    }
}
